/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Legal_NameInputs */

const en_label_legal_name = /** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Business Name`)
};

const es_label_legal_name = /** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre Legal de la Empresa`)
};

const fr_label_legal_name = /** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom légal de l'entreprise`)
};

const de_label_legal_name = /** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offizieller Unternehmensname`)
};

const id_label_legal_name = /** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Resmi Bisnis`)
};

/** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */
const ja_label_legal_name = en_label_legal_name;

/** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */
const zh_label_legal_name = en_label_legal_name;

/** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */
const ar_label_legal_name = en_label_legal_name;

/** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */
const it_label_legal_name = en_label_legal_name;

/** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */
const ru_label_legal_name = en_label_legal_name;

/** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */
const pt_label_legal_name = en_label_legal_name;

/** @type {(inputs: Label_Legal_NameInputs) => LocalizedString} */
const ko_label_legal_name = en_label_legal_name;

/**
* | output |
* | --- |
* | "Legal Business Name" |
*
* @param {Label_Legal_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_legal_name = /** @type {((inputs?: Label_Legal_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Legal_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_legal_name(inputs)
	if (locale === "es") return es_label_legal_name(inputs)
	if (locale === "fr") return fr_label_legal_name(inputs)
	if (locale === "de") return de_label_legal_name(inputs)
	if (locale === "ja") return ja_label_legal_name(inputs)
	if (locale === "zh") return zh_label_legal_name(inputs)
	if (locale === "ar") return ar_label_legal_name(inputs)
	if (locale === "id") return id_label_legal_name(inputs)
	if (locale === "it") return it_label_legal_name(inputs)
	if (locale === "ru") return ru_label_legal_name(inputs)
	if (locale === "pt") return pt_label_legal_name(inputs)
	return ko_label_legal_name(inputs)
});